// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ApiRequest } from "_core/apis/ApiRequest";
import { setMasterData } from "_core/slices/datas/MasterSlice";
import { setApiTimestamp, setTransactionData, mergeTransactionData } from "_core/slices/datas/TransactionSlice";


const AdminUserDictionaryAssetUploadApi = () => {
    const dispatch = useDispatch();

    // API固有の設定、URLとリクエスト
    const url = "/admin/user_dictionary_asset_upload";

    // API実行, asset_type, file ,file_name
    const ExecAdminUserDictionaryAssetUploadApi = async (select_file, file_name) => {
        // 必要なリクエストを定義
        const requestParams = {
        };

        const requestBinaryParams = {
            file: {
                file: select_file,
                filename: file_name
            }
        };
    
    
        let response = null;
        let error = null;
        // console.log(url + "API開始");
        try {
            response = await ApiRequest({  url:url, requestParams:requestParams,requestBinaryParams:requestBinaryParams, timeout:60*60*1000});
            // console.log(response);
        } catch (e) {
            // console.log(e);
            error = e;
        } finally {
            // console.log(url + "　API終了");
        }

        // レスポンスがあれば、データ更新
        if (response !== null && response.error_code === 0)
        {
            dispatch(setApiTimestamp(response['now_time']));
            if(response['t_asset'] !=null)
            {
                dispatch(mergeTransactionData({
                    tAssetList:[response['t_asset']]
                }));
            }
            if(response['t_user_add'] !=null)
            {
                dispatch(setTransactionData({
                    tUserAdd:response['t_user_add']
                }));
            }
        }

        return { response, error };
    };

    return ExecAdminUserDictionaryAssetUploadApi;
};

export default AdminUserDictionaryAssetUploadApi;